<template>
    <v-navigation-drawer>
    <v-list>
        <v-list-item
        v-for="(item, i) in showitems"
        :key="i"
        :value="item.id"
        :to="item.link"
        color="primary">

        <template v-slot:prepend>
            <v-icon :icon="item.icon"></v-icon>
        </template>

        <v-list-item-title v-text="item.text"></v-list-item-title>
        
        </v-list-item>
    </v-list>
    </v-navigation-drawer>
</template>


<script>

export default {
  name: 'TopMenu',

  data: () => ({
      items: [
        { id: 0, text: 'ユーザー', icon: 'mdi-account-multiple', link: '/user', loginshow: false},
        { id: 1, text: 'スポーツ店 リスト', icon: 'mdi-home', link: '/sportsstore', loginshow: false},
        { id: 2, text: 'スポーツ店 新規追加', icon: 'mdi-home', link: '/sportsstoreedit', loginshow: true},
        { id: 3, text: 'チーム・部活・サークルメンバー募集（仮）', icon: 'mdi-star', link: '/carouselcomponent' , loginshow: false},
      ],
      selectedItem: 1,
      currentComponent: "UsersList",
    }),
    computed: {
      showitems() {
        if (this.$store.getters.getToken) {
          // ログイン中
          return this.items
        } else {
          // ログインしてない
          return this.items.filter(item => item.loginshow === false)
        }
      }
    },
}
</script>